class AppRoutes {
  /**
   * The AppRoutes class defines the `getInstance` method that lets clients access
   * the unique AppRoutes instance.
   */
  private static instance: AppRoutes;
  /**
   * The AppRoutes's constructor should always be private to prevent direct
   * construction calls with the `new` operator.
   */
  private constructor() {}
  /**
   * The static method that controls the access to the singleton instance.
   * This implementation let you subclass the Singleton class while keeping
   * just one instance of each subclass around.
   */
  public static getInstance(): AppRoutes {
    if (!this.instance) {
      return (AppRoutes.instance = new AppRoutes());
    }
    return this.instance;
  }

  // paths
  getBasePath(): string {
    return "/";
  }
  getSignInPagePath(): string {
    return "/signin";
  }
  getSignInPageUrl(): string {
    return this.getSignInPagePath();
  }

  getExamplePagePath(): string {
    return `/address/:addressId/view`;
  }

  getExamplePageUrl(): string {
    return this.getExamplePagePath();
  }

  getRegisterPagePath(): string {
    return "/signup/parent";
  }
  getSchoolRegisterPagePath(): string {
    return "/signup/school";
  }

  getRegisterPageUrl(): string {
    return this.getRegisterPagePath();
  }
  getForgetPasswordPagePath(): string {
    return "/recoverPassword";
  }
  getForgetPasswordPageUrl(): string {
    return this.getForgetPasswordPagePath();
  }
  getResearchResultsPath(): string {
    return `/research-results/:country/:edusystem/:edulevel`;
  }

  getNewSchoolProfilePage(): string {
    return `/create-school-profile`;
  }
  getResearchResultsPageUrl(
    country: string,
    edusystem: string,
    edulevel: string
  ): string {
    return this.getResearchResultsPath()
      .replace(":country", country)
      .replace(":edusystem", edusystem)
      .replace(":edulevel", edulevel);
    // School details page
  }

  getSchoolDetailsPath(): string {
    return `/details/:id`;
  }

  getSchoolDetailsPageUrl(id: string): string {
    return this.getSchoolDetailsPath().replace(":id", id);
  }

  getNotificationPagePath(): string {
    return "/all-notifications";
  }
  getNotificationPageUrl(): string {
    return this.getNotificationPagePath();
  }
  getParentProfilePath(): string {
    return "/profile/parent";
  }

  // Example on a path with dynamic variables
  getExampleByIdPagePath(): string {
    return `/example/:id`;
  }

  getExampleByIdPageUrl(id: string): string {
    return this.getExampleByIdPagePath().replace(":id", id);
  }
  getSchoolProfilePage(): string {
    return "/school-profile";
  }
  getPaymentPagePath(): string {
    return "/payment";
  }
  getPaymentPageUrl(): string {
    return this.getPaymentPagePath();
  }
}

export const appRoutesObj = AppRoutes.getInstance();
